import { render } from "./AddPaperDialog.vue?vue&type=template&id=73671422&scoped=true"
import script from "./AddPaperDialog.vue?vue&type=script&lang=js"
export * from "./AddPaperDialog.vue?vue&type=script&lang=js"

import "./AddPaperDialog.vue?vue&type=style&index=0&id=73671422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73671422"]])

export default __exports__